import 'angular';

import { downgradeComponent } from '@angular/upgrade/static';

import { NotificationsComponent } from './notifications.component';

angular.module('app-lite.messages.notifications', [])
  .directive('worNotifications', downgradeComponent({ component: NotificationsComponent }));
